import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-overige-schenkingen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-overige-schenkingen.component.html',
  styleUrl: './tekst-overige-schenkingen.component.scss',
})
export class TekstOverigeSchenkingenComponent {}
